import { render } from "./AdminAnalytics.vue?vue&type=template&id=4c1d9c7a"
import script from "./AdminAnalytics.vue?vue&type=script&lang=js"
export * from "./AdminAnalytics.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Gelo\\Desktop\\Firebase Project\\eporrtfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__